import { styled } from "@mui/material";

export const DashListBox = styled("ul")(
    ({ theme }) => (
        {
            padding: 0,
            paddingInlineStart: theme.spacing(2)
        })
);